import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "../Reveal";

const FORMATS = [
  ["200 ml", "Bongo Bloom · Compact"],
  ["1 L", "Grow · A Bloom · B Bloom · PK"],
  ["1,2 L", "Bongo Bloom · Compact"],
  ["6 L", "Gran formato · toda la gama"],
  ["12 L", "Grow · A Bloom · B Bloom · PK"],
];

export const JFormats = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  return (
    <section ref={ref} id="formatos" data-testid="formats-section" className="relative py-24 md:py-32 bg-[#143823] border-y border-[#F2B441]/25 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <div className="relative aspect-square md:aspect-[5/4] overflow-hidden rounded-[10px] label-frame"
            style={{ clipPath: "polygon(0 0, 100% 0, 100% 90%, 90% 100%, 0 100%)" }}>
            <motion.img style={{ y, scale: 1.2 }} src="/img/envases.jpg" alt="Envases Jungle Nutrient en la selva" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,transparent_45%,rgba(14,42,28,0.55))]" />
          </div>
        </div>
        <div className="lg:col-span-5 order-1 lg:order-2">
          <Reveal>
            <p className="font-mono-d text-[11px] tracking-[0.22em] uppercase text-[#8CD05A] mb-6">Formatos</p>
            <h2 className="font-serif-d font-black text-5xl md:text-6xl leading-[0.92] tracking-tight">
              Del armario <span className="italic font-semibold text-[#F2B441]">a la plantación.</span>
            </h2>
            <p className="text-[#C9D6C2] mt-6 leading-relaxed">Formato de cultivador en 200 ml, 1 L y 1,2 L, y gran formato de 6 L (toda la gama) y 12 L (Grow, A Bloom, B Bloom y PK) para producciones profesionales.</p>
          </Reveal>
          <div className="mt-10 grid grid-cols-2 [&>*:first-child]:col-span-2 gap-3">
            {FORMATS.map(([s, d], i) => (
              <Reveal key={s} delay={i * 0.07}>
                <div data-testid={`format-${i}`} className="rounded-[8px] border border-[#F2B441]/30 bg-[#0E2A1C] p-5 h-full hover:border-[#F2B441] transition-colors">
                  <p className="font-label text-4xl text-label-gold">{s}</p>
                  <p className="text-[#C9D6C2] text-sm mt-2">{d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
